<div
  class="bn-progress-circle bn-progress-circle--{{ contextType }}
  bn-progress-circle--{{ size }}">
  <div class="bn-progress-circle__inner">
    <div
      class="bn-progress-circle__inner__pie bn-progress-circle__inner__pie--spinner"
      [style.transform]="progressProps.transform"
      [style.transition-duration]="transitionDuration"></div>
    <div
      class="bn-progress-circle__inner__pie bn-progress-circle__inner__pie--filler"
      [style.opacity]="progressProps.fillOpacity"></div>
    <div
      class="bn-progress-circle__inner__mask"
      [style.opacity]="progressProps.maskOpacity"></div>
  </div>
</div>
